import React from 'react'

const RightServiceRecentSection2 = (props) => {
  return (
    <div className="third mt-7 flex">
    <img
      className="w-40 cursor-pointer rounded-md"
      src={props.image}
      alt=""
    />
    <div className="my-4">
      <h1 className="mx-11 cursor-pointer text-lg font-semibold hover:text-amber-400">
        {props.date}
      </h1>
      <h1 className="mx-11 text-justify">{props.description}</h1>
    </div>
  </div>
  )
}

export default RightServiceRecentSection2